import { BeanBase } from './beanBase.ts';

export class BeanAopMethodBase extends BeanBase {}
